module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_RO-d82a160dded3a5ff2a8b6434dfd19c16.svg";